export default "__VITE_ASSET__DpLmysOH__"